import React, { useState } from "react";
import Footer from '../Footer/Footer';
import Banner from "../assets/images/brand2.jpg";

const Get3Quotes = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    website: "",
    contactPerson: "",
    businessEmail: "",
    phone: "",
    description: "",
    serviceName: "",
    document: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, document: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  return (
    <div>
      {/* Banner Section */}


      <section className="page-header no-header bg-skyblue py-2">
      <div className="container py-4 pb-2">
          <div className="row page-introduction">
            <div className="col-12">

              <div className="d-flex align-items-center justify-content-start">
                <div className="text-start">
                  <h3 className="mt-0">Get3Quotes</h3>
                  <p className="text-muted">
              We Identify top service providers for your requirement. We will
              send top 3 service providers to you.
            </p>


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="bg-white">
      <div className="vertical-gradient py-5">
        <div className="container">
            <div className="row py-4 align-items-center justify-content-center">
                <div className="col-md-6 col-lg-6 col-xl-6 text-start mb-4 pe-5 px-lg-2">
                <span className="text-primary fs-4"> </span>
                  <h1 className="display-5 fw-600 my-3">Send Proposal</h1>
                  <p className="mb-4 w-75 pt-0 pb-4 fs-5">
                  Compare, choose, and save—effortlessly!
                  </p>
                <form onSubmit={handleSubmit}>
        <div className="row">
            <div className="col-md-6 mb-4">
              <label className="form-label">Company Name</label>
              <input type="text" className="form-control" name="companyName" value={formData.companyName} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-4">
              <label className="form-label">Website</label>
              <input type="text" className="form-control" name="website" value={formData.website} onChange={handleChange} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="form-label">Contact Person Name</label>
              <input type="text" className="form-control" name="contactPerson" value={formData.contactPerson} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-4">
              <label className="form-label">Business Email ID</label>
              <input type="email" className="form-control" name="businessEmail" value={formData.businessEmail} onChange={handleChange} required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="form-label">Phone No.</label>
              <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-4">
              <label className="form-label">Seeking Looking For</label>
              <input type="text" className="form-control" name="serviceName" value={formData.serviceName} onChange={handleChange} required />
            </div>
          </div>
          <div className="mb-4">
            <label className="form-label">Your Requirement</label>
            <textarea className="form-control" name="description" value={formData.description} onChange={handleChange} required></textarea>
          </div>
          <div className="mb-4">
            <label className="form-label">Attach Document (Optional)</label>
            <input type="file" className="form-control" name="document" onChange={handleFileChange} />
          </div>
          <button type="submit" className="btn mt-3 p-3 px-4 btn-lg btn-primary">Get3Quotes</button>
        </form>




                </div>
                <div className="col-md-6 col-lg-6 col-xl-6">
                  <div className="ms-5 py-5">
                <img src={Banner} className="img-fluid" alt="LeadStream" title="LeadStream" width={700} />
                </div>
                </div>
            </div>
        </div>
      </div>
      </div>


      <section className="bg-white border-top py-5 p-5 ">
      <div className="container">
      <div className="row py-4 align-items-center justify-content-center">
        <div className="col-12 text-center">
      <h1 className="display-6 fw-600 my-3">One Stop Solution</h1>
                  <p className="mb-4 pt-0 pb-3 fs-5">
                  Result driven IT & Digital Marketing Company
                  </p>
                  </div>
                  </div>

          <div className="d-lg-flex d-sm-block justify-content-around">
            <div className="text-center py-4">
              <h3 className="display-3 fw-600">5+</h3>
              <p className="text-muted fs-5">Team Experience</p>
            </div>
            <div className="text-center py-4">
              <h3  className="display-3 fw-600">100+</h3>
              <p className="text-muted fs-5">Clients across 5 countries</p>
            </div>

            <div className="text-center py-4">
              <h3  className="display-3 fw-600">500+</h3>
              <p className="text-muted fs-5">Projects</p>
            </div>
          </div>
        </div>
        </section>



      <section className="bg-light py-5 p-5 ">
<div class="container">

<div className="row py-4 align-items-center justify-content-center">
        <div className="col-12 text-center">
      <h2 className="display-6 fw-600 my-3">Problems We Have Solved</h2>
                  <p className="mb-4 pt-0 pb-3 fs-5">
                  Result driven IT & Digital Marketing Company
                  </p>
                  </div>
                  </div>
    <div class="row align-items-center justify-content-center g-4">
        <div class="col-md-4 px-4 mb-3">
            <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Software Delivery <br /> Workflows</h5>
                    <p class="card-text">Streamlining the process of delivering high-quality software.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Standardization in Development Processes</h5>
                    <p class="card-text">Ensuring consistency and best practices across teams.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Software Development Cycles Optimization</h5>
                    <p class="card-text">Enhancing efficiency and reducing time-to-market.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Managing and Tracking Project Progress</h5>
                    <p class="card-text">Monitoring project milestones and deliverables effectively.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Quality Assurance and Testing Procedures</h5>
                    <p class="card-text">Implementing robust testing for bug-free software.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Scalability and Adaptability of IT Services</h5>
                    <p class="card-text">Ensuring systems can grow and evolve with demand.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Risk Assessment and Mitigation Strategies</h5>
                    <p class="card-text">Identifying and minimizing potential project risks.</p>
                </div>
            </div>
        </div>
        <div class="col-md-4 px-4 mb-3">
        <div class="card p-4 rounded-4 shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">Managing Resources and Project Dependencies</h5>
                    <p class="card-text">Optimizing resource allocation and dependency management.</p>
                </div>
            </div>
        </div>
    </div>
</div>


</section>



<section className="bg-white py-5 p-5 ">
        <div className="container">
          <div className="d-lg-flex d-sm-block py-5 justify-content-around">
            <div className="text-center py-4">
              <h3 className="display-3 fw-600">11 M</h3>
              <p className="text-muted fs-5">Leads Generated</p>
            </div>
            <div className="text-center py-4">
              <h3  className="display-3 fw-600">86%</h3>
              <p className="text-muted fs-5">Increase in Organic Traffic</p>
            </div>

            <div className="text-center py-4">
              <h3  className="display-3 fw-600">48+</h3>
              <p className="text-muted fs-5">Improvement in cost per lead</p>
            </div>
          </div>
        </div>
</section>



    <section>
    <div className="bg-light pt-5">
          <div className="container-md pb-5">
          <div className="justify-content-center text-center row mt-4">
            <div className="col-lg-12 col-xl-6">
        <h2 className="text-center display-6 fw-semibold">FAQ'S</h2>
          <p className="fs-5 pt-2">Got a question to ask us? Use the list below to find answers to our most frequently asked questions.</p>
        </div>
        </div>
<div class="row justify-content-center text-start">
<div class="col-sm-12 col-lg-12 col-xl-9">
<div className="accordion my-4" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button
        className="accordion-button py-4 py-4"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        What is the purpose of this platform?
      </button>
    </h2>
    <div
      id="collapseOne"
      className="accordion-collapse collapse show"
      aria-labelledby="headingOne"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        Our platform connects employers with talented candidates. It simplifies the hiring process by offering advanced tools for job posting, candidate screening, and communication.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingTwo">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
        aria-expanded="false"
        aria-controls="collapseTwo"
      >
        How do I post a job?
      </button>
    </h2>
    <div
      id="collapseTwo"
      className="accordion-collapse collapse"
      aria-labelledby="headingTwo"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To post a job, simply create an account, navigate to the job posting section, and fill in the required details about the job and your company. Your job will be visible to potential candidates immediately.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingThree">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseThree"
        aria-expanded="false"
        aria-controls="collapseThree"
      >
        Can I filter candidates?
      </button>
    </h2>
    <div
      id="collapseThree"
      className="accordion-collapse collapse"
      aria-labelledby="headingThree"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        Yes, our platform provides various filters to help you find the best candidates based on skills, experience, location, and more.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingFour">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFour"
        aria-expanded="false"
        aria-controls="collapseFour"
      >
        How do I purchase jobs or CV Database access online?
      </button>
    </h2>
    <div
      id="collapseFour"
      className="accordion-collapse collapse"
      aria-labelledby="headingFour"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To purchase jobs or CV Database access, log in to your account, navigate to the purchase section, and select the package that best fits your needs. Follow the prompts to complete the payment process.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingFive">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFive"
        aria-expanded="false"
        aria-controls="collapseFive"
      >
        How do I log in as a recruiter?
      </button>
    </h2>
    <div
      id="collapseFive"
      className="accordion-collapse collapse"
      aria-labelledby="headingFive"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To log in as a recruiter, go to the login page, enter your recruiter credentials (email and password), and click the "Log In" button. If you don’t have an account, you can register by clicking on the "Sign Up" button.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingSix">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSix"
        aria-expanded="false"
        aria-controls="collapseSix"
      >
        I have forgotten my password or am having trouble logging in.
      </button>
    </h2>
    <div
      id="collapseSix"
      className="accordion-collapse collapse"
      aria-labelledby="headingSix"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        If you have forgotten your password or are having trouble logging in, click the "Forgot Password" link on the login page. Follow the instructions to reset your password. If you continue to have issues, contact support for assistance.
      </div>
    </div>
  </div>

  </div>
  </div>
</div>
</div>
</div>
    </section>

    <Footer />
    </div>
  );
};

export default Get3Quotes;
